import { nonEmptyArray as NEA, option as O } from "fp-ts";
import { pipe } from "fp-ts/lib/function";
import { NonEmptyArray } from "fp-ts/lib/NonEmptyArray";

export function renderNonEmpty<T, Ret>(arr: Array<T>, f: (nea: NonEmptyArray<T>) => Ret): Ret | null {
  return pipe(
    arr,
    NEA.fromArray,
    O.foldW(
      () => null,
      nea => f(nea),
    ),
  );
}

// export const RenderNonEmpty = <T,>(props: {
//   arr: Array<T>;
//   Component: React.FC<{ items: NonEmptyArray<T> }>;
// }): React.ReactNode | null => {
//   return pipe(
//     props.arr,
//     NEA.fromArray,
//     O.foldW(
//       () => null,
//       nea => <props.Component items={nea} />,
//     ),
//   );
// };
